import { Button } from '@shared/components/ui/button';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loader2 } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useExportPayments } from '../../hooks';

interface ExportPaymentsButtonProps {
  fileId: number;
  sorting?: { column: string; direction: 'asc' | 'desc' };
  columns?: string[];
  disabled?: boolean;
}

export const ExportPaymentsButton: FC<ExportPaymentsButtonProps> = ({ fileId, sorting, columns, disabled = false }) => {
  const { t } = useTranslation('codCourierFileDetail');
  const { exportPayments, isExporting } = useExportPayments();

  const handleExport = () => {
    exportPayments(fileId, columns, sorting);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting || disabled}
      type="button"
      size="sm"
      variant="outline"
      className={`!py-[9px] !px-2 text-icon bg-body-bg transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="export-payments-button"
      title={t('export.button', 'Exportar a Excel')}
    >
      {isExporting ? <Loader2 className="h-4 w-4 animate-spin" /> : <FontAwesomeIcon icon={faFileArrowDown} />}
    </Button>
  );
};
